


















































import { Component, Emit, Vue, Prop } from 'vue-property-decorator';
import ScoreButton from './ScoreButton.vue';
import { Theme } from '../types';
@Component({
  components: { ScoreButton },
})
export default class Settings extends Vue {
  @Prop({ required: true }) active!: boolean;
  @Prop({ required: true }) close!: Function;
  @Prop({ required: true }) select!: Function;
  @Prop({ required: true }) themes!: Array<Theme>;
  @Prop({ required: true }) themeIdx!: number;
}
